import claudiImg from './claudi_sticker.png';
import './ClaudiCharacter.css';

/** Claudi mascot next to the reward speech bubble. */
export function ClaudiCharacter() {
  return (
    <img
      className="sticker-reward-claudi-character"
      src={claudiImg}
      alt=""
      draggable={false}
      aria-hidden
    />
  );
}
